import { 
  IWalletAdapter, 
  WalletInfo, 
  ConnectOptions, 
  TransactionRequest,
  WalletType 
} from '../core/types';
import { EventEmitter } from 'events';

export abstract class BaseAdapter extends EventEmitter implements IWalletAdapter {
  protected _isConnected: boolean = false;
  protected _address: string | null = null;
  protected _chainId: string | null = null;
  protected _provider: any = null;
  protected _walletType: WalletType = WalletType.UNKNOWN;

  abstract connect(options?: ConnectOptions): Promise<WalletInfo>;
  abstract disconnect(): Promise<void>;
  abstract sendTransaction(tx: TransactionRequest): Promise<string>;
  abstract signMessage(message: string): Promise<string>;
  abstract switchChain(chainId: string): Promise<void>;

  async getAccount(): Promise<string | null> {
    return this._address;
  }

  async getChainId(): Promise<string | null> {
    return this._chainId;
  }

  isConnected(): boolean {
    return this._isConnected;
  }

  onAccountsChanged(callback: (accounts: string[]) => void): void {
    this.on('accountsChanged', callback);
  }

  onChainChanged(callback: (chainId: string) => void): void {
    this.on('chainChanged', callback);
  }

  onDisconnect(callback: () => void): void {
    this.on('disconnect', callback);
  }

  protected handleAccountsChanged(accounts: string[]): void {
    if (accounts.length === 0) {
      this._isConnected = false;
      this._address = null;
      this.emit('disconnect');
    } else {
      this._address = accounts[0];
      this.emit('accountsChanged', accounts);
    }
  }

  protected handleChainChanged(chainId: string): void {
    this._chainId = chainId;
    this.emit('chainChanged', chainId);
  }

  protected handleDisconnect(): void {
    this._isConnected = false;
    this._address = null;
    this._chainId = null;
    this._provider = null;
    this.emit('disconnect');
  }
}